import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-section-header',
  templateUrl: './app-section-header.component.html',
  styleUrls: ['./app-section-header.component.scss'],
})
export class AppSectionHeaderComponent {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() badge: string = '';
  @Input() badgeVariant: 'blue' | 'green' | 'amber' | 'red' | 'gray' = 'blue';
  @Input() isFirst: boolean = false;
  @Input() noBorder: boolean = false;
  @Input() customClass: string = '';
}
